module.exports = __webpack_public_path__ + "img/group@3x.d7066ee9.png";